<div #chart id="chart" (window:resize)="onResize($event)"></div>
